import React from "react";
import { Image } from "./image";


export const Event = (props) => {
  return (
    <div id="events" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Annwesha's Edition</h2>
          <p>
           List of Edition of Annwesha
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <div className="card">
                    <div className="card-body">
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                      url1={d.url}
                    />
                    <h5 className="card-title">{d.title}</h5>
                    </div>
                    </div>
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
